import { Navigate } from 'react-router'
import { useDashboard } from '@hooks/useDashboard'
import { useResourcePermissions } from '@hooks/useResourcePermissions'
import { BuilderAreaExisting } from './BuilderArea/BuilderArea'

export default function ExistingDashboardGate({ id }: { id: string }) {
  const dashboard = useDashboard(id)
  const { canEdit } = useResourcePermissions(dashboard?.owner.id)

  if (!dashboard) return null

  if (!canEdit) {
    return <Navigate to={`/dashboards/${id}`} replace />
  }

  return <BuilderAreaExisting id={id} />
}
